export enum PlaceholderEnum {
  AllFile = 'Search in All Files',
  RecentFolders = 'Search in Recent Folders',
  StarredFiles = 'Search in Starred Files',
  DeletedFiles = 'Search in Deleted Files'
}

export enum NavigationEnum {
  AllFile = 'all-files',
  RecentFolders = 'recent-folders',
  StarredFiles = 'starred-files',
  DeletedFiles = 'deleted-files'
}
